module.exports = __webpack_public_path__ + "static/img/refresh-cache-step1.7f521e17.png";